<template>
  <transition
    name="toast-slide"
    enter-active-class="animated slideInUp"
    leave-active-class="animated slideOutDown">
    <section class="containerToast bookFont">
      <div class="containerToast__message">
        {{message}}
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  props: ['message']
}
</script>
